import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { PerformanceOverviewService } from './performance-overview.service';

const service = new PerformanceOverviewService();

export interface PerformanceOverviewState {}

const PerformanceOverviewStore: Module<PerformanceOverviewState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async getPerformanceOverview(context, payload: { customerId: number; employeeId: number; query?: LocationQuery }) {
         const response = await service.getPerformanceOverview(payload.customerId, payload.employeeId, payload.query);
         return response;
      },
   },
};

export default PerformanceOverviewStore;
